import { render, staticRenderFns } from "./verificaCoperturaButton.vue?vue&type=template&id=78c07d4d&"
import script from "./verificaCoperturaButton.vue?vue&type=script&lang=js&"
export * from "./verificaCoperturaButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports